import React, { useState, useMemo } from 'react';
import SectionHeader from '../../ui/SectionHeader';
import LocationsCarousel from './LocationsCarousel';
import CarWashModal from '../../common/modal/CarWashModal';
import LocationFilter from './LocationFilter';
import '../../../styles/components/sections/Locations.css';

const Locations = ({ carWashes }) => {
  const [selectedCity, setSelectedCity] = useState('Sve lokacije');
  const [selectedTownship, setSelectedTownship] = useState('Sve opštine');
  const [selectedCarWash, setSelectedCarWash] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const cities = useMemo(() => {
    const uniqueCities = [...new Set(carWashes.map(cw => cw.city).filter(Boolean))];
    return ['Sve lokacije', ...uniqueCities];
  }, [carWashes]);

  const townships = useMemo(() => {
    if (selectedCity !== 'Beograd') return [];
    const belgradeTownships = carWashes
      .filter(cw => cw.city === 'Beograd')
      .map(cw => cw.township)
      .filter(Boolean);
    return ['Sve opštine', ...new Set(belgradeTownships)];
  }, [carWashes, selectedCity]);

  const filteredCarWashes = useMemo(() => {
    let filtered = carWashes;
    if (selectedCity !== 'Sve lokacije') filtered = filtered.filter(cw => cw.city === selectedCity);
    if (selectedCity === 'Beograd' && selectedTownship !== 'Sve opštine') {
      filtered = filtered.filter(cw => cw.township === selectedTownship);
    }
    return filtered;
  }, [carWashes, selectedCity, selectedTownship]);

  return (
    <section id="locations" className="locations-section-area">
      <div className="container">
        <SectionHeader
          badge="Gde prati?"
          title="Naše lokacije"
          subtitle="Pronađi najbližu ClickWash perionicu u svom gradu."
          icon="📍"
        />

        {/* Filter je sada unutar toka, pre karusela */}
        <div className="filter-and-carousel-stack">
          <LocationFilter 
            cities={cities}
            townships={townships}
            selectedCity={selectedCity}
            selectedTownship={selectedTownship}
            onCityChange={(city) => { setSelectedCity(city); setSelectedTownship('Sve opštine'); }}
            onTownshipChange={setSelectedTownship}
          />

          <div className="locations-carousel-wrapper">
            <LocationsCarousel 
              locations={filteredCarWashes}
              onViewDetails={(cw) => { setSelectedCarWash(cw); setIsModalOpen(true); }}
            />
          </div>
        </div>
      </div>

      <CarWashModal 
        carWash={selectedCarWash}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </section>
  );
};

export default Locations;